"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _InteractionWithNavigationConfirmation = _interopRequireDefault(require("customer-data-communicator/components/wrappers/InteractionWithNavigationConfirmation"));

var _InteractionWithNavigationConfirmationEmailComponentConfig = _interopRequireDefault(require("customer-data-communicator/components/interactions/email/config/InteractionWithNavigationConfirmationEmailComponentConfig"));

var _default = (0, _InteractionWithNavigationConfirmation.default)(_InteractionWithNavigationConfirmationEmailComponentConfig.default);

exports.default = _default;
module.exports = exports.default;